import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
  RedditShareButton,
  TumblrShareButton,
  TelegramShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  EmailIcon,
  RedditIcon,
  TumblrIcon,
  TelegramIcon,
} from "react-share";

interface BottomDrawerProps {
  open: any;
  close: any;
}

const BottomDrawer: React.FC<BottomDrawerProps> = ({ open, close }) => {
  const [url, setUrl] = useState("");
  const urlToShare = "https://salontym.com";

  useEffect(() => {
    if (typeof window !== "undefined" || typeof window !== null) {
      setUrl(window.location.href);
    }
  }, []);

  const shareMessage = `Hey, I recently took Sparkling Celebration from SalonTym and was quite impressed with it. Therefore, I am referring it to you. Book this service via this link ${url} and get Rs 100 off as a first service order discount!`;

  // Function to get Share Buttons
  const getShareButtons = () => {
    return [
      {
        platform: "Facebook",
        button: (
          <FacebookShareButton url={urlToShare} title={shareMessage}>
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
        ),
      },
      {
        platform: "Twitter",
        button: (
          <TwitterShareButton url={urlToShare} title={shareMessage}>
            <TwitterIcon size={32} round={true} />
          </TwitterShareButton>
        ),
      },
      {
        platform: "WhatsApp",
        button: (
          <WhatsappShareButton url={urlToShare} title={shareMessage}>
            <WhatsappIcon size={32} round={true} />
          </WhatsappShareButton>
        ),
      },
      {
        platform: "LinkedIn",
        button: (
          <LinkedinShareButton url={urlToShare}>
            <LinkedinIcon size={32} round={true} />
          </LinkedinShareButton>
        ),
      },
      {
        platform: "Email",
        button: (
          <EmailShareButton
            url={urlToShare}
            subject="Check this out!"
            body={`${shareMessage} ${urlToShare}`}
          >
            <EmailIcon size={32} round={true} />
          </EmailShareButton>
        ),
      },

      {
        platform: "Reddit",
        button: (
          <RedditShareButton url={urlToShare}>
            <RedditIcon size={32} round={true} />
          </RedditShareButton>
        ),
      },
      {
        platform: "Tumblr",
        button: (
          <TumblrShareButton url={urlToShare}>
            <TumblrIcon size={32} round={true} />
          </TumblrShareButton>
        ),
      },
      {
        platform: "Telegram",
        button: (
          <TelegramShareButton url={urlToShare}>
            <TelegramIcon size={32} round={true} />
          </TelegramShareButton>
        ),
      },
    ];
  };

  // Get share buttons
  const shareButtons = getShareButtons();

  return (
    <Drawer
      open={open}
      onClose={close}
      anchor="bottom"
      sx={{
        zIndex: 10000,
        "& .MuiDrawer-paper": {
          background: "#fff",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          width: "100%",
          padding: "1rem",
        },
      }}
      PaperProps={{
        sx: {
          height: "auto",
          padding: "1rem",
          maxWidth: "100%",
        },
      }}
      role="presentation"
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton onClick={close} sx={{ color: "black" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Typography variant="h6" sx={{ textAlign: "center", margin: "auto" }}>
        Share this page
      </Typography>

      <List>
        {/* Render Share Buttons */}
        <Grid container item xs={12} sm={10} md={10} lg={10} margin="auto">
          {shareButtons.map((button, index) => (
            <Grid item xs={3} sm={3} md={3} lg={3} margin="auto" key={index}>
              <ListItem sx={{ justifyContent: "center" }}>
                {button.button}
              </ListItem>
              <ListItemText
                sx={{ justifyContent: "center", textAlign: "center" }}
                primary={button.platform}
              />
              <br />
            </Grid>
          ))}
        </Grid>
      </List>
    </Drawer>
  );
};

interface ShareServiceProps {
  drawerOpen: any;
  closeDrawer: any;
}

const ShareService: React.FC<ShareServiceProps> = ({
  drawerOpen,
  closeDrawer,
}) => {
  return (
    <div>
      <BottomDrawer open={drawerOpen} close={closeDrawer} />
    </div>
  );
};

export default ShareService;
